<sbd-account-portal-frontend-bond-cancellation
  #form
  [currentOpenQR]="concernedQuoteRequest"
  (requestSubmitted)="closeDrawer()"
  (canSubmitChange)="canSubmit = $event"></sbd-account-portal-frontend-bond-cancellation>
<cipx-action-bar [sticky]="true" [useContainerWidth]="true" [removeStickyOnMobile]="true" [justify]="'start'">
  <cipx-primary-button [disabled]="!canSubmit" (buttonClick)="onSubmit()">Submit Request</cipx-primary-button>
  <cipx-cancel-button (buttonClick)="closeDrawer()">Cancel</cipx-cancel-button>
</cipx-action-bar>
